import { createSlice } from '@reduxjs/toolkit';

const orchestratorSlice = createSlice({
  name: 'orchestrator',
  initialState: {
    sidebarSticky: true, // Default to sticky behavior
  },
  reducers: {
    setSidebarSticky: (state, action) => {
      state.sidebarSticky = action.payload;
    },
    toggleSidebarSticky: (state) => {
      state.sidebarSticky = !state.sidebarSticky;
    },
  },
});

export const { setSidebarSticky, toggleSidebarSticky } = orchestratorSlice.actions;
export default orchestratorSlice.reducer;
